import { HeaderMall9 } from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import WhiteSpec from "../../../../../publicComponent/h5/WhiteSpec";
import Button from "../../../../../publicComponent/Button";
import BreadCrumbs from "../../../../../publicComponent/BreadCrumbs";
import ItemsTitle from "./components/ItemsTitle";
import Schedule from "./components/Schedule";
import GoodsCard from "./components/GoodsCard";
import BillCard from "./components/BillCard";
import { useEffect, useState } from "react";
import ShippingAddressItem from "./components/ShippingAddressItem";
import { config, getOrderStatus } from "../../../../../utils";
import { useTranslation } from "react-i18next";
import PayModal from "../../../../../publicComponent/PayModal";
import HeadBg from "./head-bg.png";
import OrderDetailContext, {
  OrderDetailController,
  useOrderDetailContext,
} from "../../../../../reducer/moduleReducer/my/orderDetail";

function OrderDetailWrap() {
  const {
    selectPayType,
    getOrderDetail,
    setPayModalVisible,
    cancelOrderHandle,
    gotoPayMethods,
  } = OrderDetailController();
  const { state } = useOrderDetailContext();
  const { t } = useTranslation();
  const { detail, payModalVisible } = state;

  useEffect(() => {
    getOrderDetail();
  }, []);

  return (
    <>
      <Navigator.container className="container-center pb-[70px]">
        <div className="relative bg-[#f0f0f0] md:hidden">
          <div className="overflow-hidden">
            <img
              src={HeadBg}
              className="absolute top-0"
              style={{ height: "80%", width: "100%" }}
            />
            {detail.orderId && (
              <div className="flex text-center justify-around items-center relative py-[15px]">
                <p className="text-white text-[16px]">
                  {t(getOrderStatus(detail.orderStatus))}
                </p>
                {/*<p className="text-[#e58d40]">剩余：23:50:50</p>*/}
                {detail.orderStatus === 0 && (
                  <p className="text-white text-[14px]">
                    需付款：${detail.receivable}
                  </p>
                )}
              </div>
            )}
          </div>
          <div className="md:hidden relative bg-white mx-[3%] rounded-[10px] px-[12px]">
            <ShippingAddressItem detail={detail} />
          </div>
        </div>
        <WhiteSpec />
        <BreadCrumbs />
        {detail.transportType === "2" && (
          <Schedule
            // openPayTypeModal={() => setPayModalVisible(true)}
            openPayTypeModal={gotoPayMethods}
            cancelOrderHandle={cancelOrderHandle}
            detail={detail}
          />
        )}
        <ItemsTitle title="商品信息"></ItemsTitle>
        {detail.orderId && (
          <div className="py-[5px] px-[15px]">
            <div className="md:divide-y divide-[#eee]">
              {detail.productList.map((goods, i) => (
                <GoodsCard data={goods} key={i} />
              ))}
            </div>
          </div>
        )}
        <WhiteSpec />
        <BillCard detail={detail} />
        <ItemsTitle title="收货信息" />
        <div className="mdmax:hidden">
          <ShippingAddressItem detail={detail} />
        </div>
      </Navigator.container>
      <div className="fixed py-[12px] pl-[26px] bg-white md:hidden flex left-0 bottom-0 container">
        {detail.orderId && detail.orderStatus === 0 && (
          <Button
            onClick={cancelOrderHandle}
            className="bg-[#eee] text-[14px] py-[10px] border border-[#DFDFDF] rounded-full mr-[15px] flex-none w-[40%]"
          >
            {t("取消订单")}
          </Button>
        )}

        {detail.orderId && detail.orderStatus === 0 && (
          <Button
            onClick={() => setPayModalVisible(true)}
            className="bg-[#ECBC40] text-[14px] py-[10px] flex-1 rounded-l-full"
          >
            {t("订单支付")}
          </Button>
        )}
      </div>
      <PayModal
        visible={payModalVisible}
        selectPayType={selectPayType}
        onClose={setPayModalVisible}
      />
    </>
  );
}

export default function OrderDetail() {
  return (
    <>
      <HeaderMall9 />
      <Navigator title="订单信息" goback />
      <OrderDetailContext>
        <OrderDetailWrap />
      </OrderDetailContext>
    </>
  );
}
